export default {
  'Extract audio': 'Ekstrak audio',
  'Mute': 'Mute',
  'Split video and audio': 'Pisahkan video dan audio',
}